import { render, staticRenderFns } from "./DedicatedNumberPaymentCheckoutModal.vue?vue&type=template&id=4b72b6f2&scoped=true&"
import script from "./DedicatedNumberPaymentCheckoutModal.vue?vue&type=script&lang=js&"
export * from "./DedicatedNumberPaymentCheckoutModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b72b6f2",
  null
  
)

export default component.exports